import React, { useState, useEffect, useMemo, useContext } from 'react';
import { Box } from '@mui/system';
import Template from '@/components/dynamicComponent/Template';
import PageHeader from '@/components/PageHeader';
import { fieldGenerator } from '@/lib/dynamicTable';
import client from '@/lib/feathers';
import { useSelector } from 'react-redux';
import { BackStageContext } from '@/contexts/BackStageContext';

export default function Personnel({ showHeader = true }) {
  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const { backStageUpdateTrigger } = useContext(BackStageContext);

  useEffect(() => {
    const getVendors = async () => {
      const CoVendor = (await client.service('menuCoVendor').find()).data.map(
        (item) => ({
          ...item,
          tableName: 'menuCoVendor',
        })
      );
      const PropertyVendor = (
        await client.service('menuPropertyVendor').find()
      ).data.map((i) => ({ ...i, tableName: 'menuPropertyVendor' }));
      setVendors([...CoVendor, ...PropertyVendor]);
    };
    getVendors();
  }, [backStageUpdateTrigger]);
  const serviceData = useSelector((state) => state.service.serviceData);

  const serviceOptions = useMemo(() => {
    return serviceData.data.map((item) => ({
      label: item.name,
      value: item.id,
    }));
  }, [serviceData]);
  const dynamicStructure = useMemo(
    () => ({
      dbName: 'menuWorkers',
      text: '人員管理名單',
      funcs: [
        {
          name: 'createData',
          text: '新增人員',
          type: 'EditButton',
          deleteStatus: true,
        },
      ],
      fields: {
        // 各欄位的資料型態
        name: fieldGenerator('name', '姓名'),
        workerId: fieldGenerator('workerIdInCompany', '員工編號'),
        company: fieldGenerator(
          'company',
          '公司名稱',
          'Select',
          {
            options: vendors.map((vendor) => ({
              value: `${vendor.tableName}-${vendor._id}`,
              label: vendor.name,
            })),
            onChange: (value) => {
              setSelectedVendor(value);
            },
          },
          {},
          {
            width: 200,
            cell: (_val, _index, record) => {
              if (vendors.length > 0 && record.tableName) {
                const { tableName, companyId } = record;

                const vendor = vendors.find(
                  (item) =>
                    item._id === companyId && item.tableName === tableName
                );
                return vendor?.name;
              }
            },
          }
        ),

        service: fieldGenerator(
          'service',
          '服務項目',
          'Select',
          {
            mode: 'multiple',
            options:
              vendors
                .find((item) => {
                  if (selectedVendor !== null) {
                    const [tableName, id] = selectedVendor.split('-');
                    return item._id === id && item.tableName === tableName;
                  }
                  return false;
                })
                ?.service.map((service) => {
                  const serviceName = serviceOptions.filter((item) => {
                    return service === item.value;
                  });

                  if (serviceName.length > 0) {
                    return {
                      value: serviceName[0].value,
                      label: serviceName[0].label,
                    };
                  }
                }) || [],
          },
          {},
          {
            width: 200,
            cell: (services) =>
              services
                .map(
                  (service) =>
                    serviceOptions.find((option) => option.value === service)
                      ?.label || ''
                )
                .join('、'),
          }
        ),

        startDate: fieldGenerator(
          'startDate',
          '到職日期',
          'DatePicker',
          {},
          {},
          {}
        ),
        photo: fieldGenerator(
          'photo',
          '照片',
          'Upload',
          {
            accept: 'image/*',
          },
          {},
          { width: 200 }
        ),
        licenses: fieldGenerator(
          'licenses',
          '證照',
          'Upload',
          {
            multiple: true,
            accept: 'image/*',
          },
          {},
          { width: 400 }
        ),
        job: fieldGenerator('job', '職稱'),
        inCharge: fieldGenerator('inCharge', '職掌內容'),
        phone: fieldGenerator('phone', '電話'),
        email: fieldGenerator(
          'email',
          '電子郵件',
          'Input',
          {},
          {},
          { width: 200 }
        ),
        remark: fieldGenerator(
          'remark',
          '備註',
          'TextArea',
          {},
          {
            rules: [],
          },
          { width: 400 }
        ),
        createTime: fieldGenerator(
          'createTime',
          '建立時間',
          'hidden',
          {},
          {},
          {
            width: 200,
          }
        ),
      },
      manipulate: [
        { name: 'editData', text: '編輯', type: 'EditButton' },
        {
          name: 'deleteData',
          text: '刪除',
          type: 'DeleteButton',
          deleteStatus: true,
        },
      ],
    }),
    [selectedVendor, serviceOptions, vendors]
  );

  return (
    <Box>
      {/* header */}
      {showHeader && (
        <PageHeader
          title="人員名單"
          breadcrumbs={[{ name: '組織管理' }, { name: '人員名單' }]}
        />
      )}
      {/* {vendors.length > 0 && ( */}
      <Template
        {...{ dynamicStructure, setSelectedVendor }}
        // setSelectedVendor={setSelectedVendor}
      />
      {/* )} */}
    </Box>
  );
}
